import React from 'react'
import NewCountryModal from '../containers/authorised/manageCountries/country/new/NewCountryModal'

export default function AppModals(props) {
  const { } = props

  return (
    <>
      <NewCountryModal />
    </>
  )
}